import { render, staticRenderFns } from "./FundCategoryPills.vue?vue&type=template&id=cb8c16aa&scoped=true"
import script from "./FundCategoryPills.vue?vue&type=script&lang=js"
export * from "./FundCategoryPills.vue?vue&type=script&lang=js"
import style0 from "./FundCategoryPills.vue?vue&type=style&index=0&id=cb8c16aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8c16aa",
  null
  
)

export default component.exports